import React from 'react';

import { Typography } from 'antd';
import styled from 'styled-components';

import Select from 'components/lib/Select';

import { useEditBatchShopRequestsModalContext } from './EditBatchShopRequestsModalContext';
import { USER_GROUPS } from '../../../constants';
import { useShopRequestsContext } from '../ShopRequestsContext';

const StyledSelect = styled(Select)`
  width: 407px;
  margin-right: 30px;
  &&&.ant-select {
    height: 36px;
  }

  &&& .ant-select-selector {
    border-radius: 0;
  }

  .ant-select-selection-item {
    font-size: 14px;
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;
`;

const StyledLabel = styled(Typography.Text)`
  font-family: var(--font-bold);
  margin-right: 10px;
`;

type Props = {
  fieldKey: 'shopper_id' | 'auditor_id';
  Label: 'Shopper' | 'Auditor';
};

const EditBatchShopRequestsModalUserSelect = ({ fieldKey, Label }: Props) => {
  const { batchShopRequests, setBatchShopRequests } = useEditBatchShopRequestsModalContext();
  const { staffUsers } = useShopRequestsContext();

  const mysteryShopAdmins = staffUsers?.filter((u) => u.groups?.includes(USER_GROUPS.MYSTERY_SHOP_ADMIN)) ?? [];

  const shoppers = staffUsers?.filter((u) => !u.groups?.includes(USER_GROUPS.MYSTERY_SHOP_ADMIN)) ?? [];

  const sourceList = fieldKey === 'auditor_id' ? mysteryShopAdmins : shoppers;

  const options = [
    { value: -1, label: 'Unassigned' },
    ...sourceList.map((user) => ({
      value: user.userId,
      label: user.name,
    })),
  ];

  const currentValue = batchShopRequests[fieldKey];

  const handleChange = (value: number) => {
    setBatchShopRequests({
      ...batchShopRequests,
      [fieldKey]: value,
    });
  };

  return (
    <Container>
      <StyledLabel>{Label}</StyledLabel>
      <StyledSelect
        options={options}
        value={currentValue}
        showSearch
        filterOption={(input, option) =>
          Boolean(option?.label) &&
          typeof option?.label === 'string' &&
          option.label.toLowerCase().includes(input.toLowerCase())
        }
        onChange={handleChange}
      />
    </Container>
  );
};

export default EditBatchShopRequestsModalUserSelect;
